export default __webpack_public_path__ + "static/media/Warlord's Cloak.e8893c84.jpg";